import { auth, firestore } from "../_firebase";
import Collection from "../_collections";

const markNotificationAsRead = notificationId => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .collection(Collection.NOTIFICATIONS)
      .doc(notificationId)
      .update({ read: true })
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject("Please try again later.");
      });
  });

  return promise;
};

const getNotifications = notificationId => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .collection(Collection.NOTIFICATIONS)
      .limit(10)
      .orderBy("createdAt", "desc")
      .get()
      .then(results => {
        let notificationResults = [];
        results.forEach(result => {
          let resultData = result.data();

          notificationResults.push(resultData);
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: notificationResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later.");
      });
  });

  return promise;
};

const loadMoreNotifications = lastResult => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;
    if (!lastResult) {
      reject("Please try again later.");
    }
    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .collection(Collection.NOTIFICATIONS)
      .doc(lastResult)
      .get()
      .then(doc => {
        if (doc.exists) {
          firestore
            .collection(Collection.USERS)
            .doc(userId)
            .collection(Collection.NOTIFICATIONS)
            .limit(10)
            .orderBy("createdAt", "desc")
            .startAfter(doc)
            .get()
            .then(results => {
              let notificationResults = [];
              results.forEach(result => {
                let resultData = result.data();

                notificationResults.push(resultData);
              });
              let lastResult = null;
              if (results.size !== 0) {
                lastResult = results.docs[results.docs.length - 1].id;
              }
              resolve({ results: notificationResults, lastResult });
            })
            .catch(err => {
              console.log(err);
              reject("Please try again later.");
            });
        } else {
          reject("Please try again later.");
        }
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later.");
      });
  });

  return promise;
};
const markAllAsRead = notificationId => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .update({ notifications: 0 })
      .then(doc => {
        resolve();
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later.");
      });
  });

  return promise;
};

const notificationsService = {
  markNotificationAsRead,
  getNotifications,
  loadMoreNotifications,
  markAllAsRead
};
export default notificationsService;



// WEBPACK FOOTER //
// ./src/_services/notificationsService.js